import { HYDRATE } from "next-redux-wrapper";
import { ActionsPromotionDetail } from "./actions";

const initialState = { data: {}, status: "fetch_init", message: "" };

function storePromotionDetail(state = initialState, action) {

	switch (action.type) {

	case HYDRATE: {

		return { ...state, ...action.payload.storePromotionDetail };

	}
	case ActionsPromotionDetail.LOAD_GET_PROMOTION_DETAIL:
		return { ...state, data: action.data, status: "fetch_loading" };
	case ActionsPromotionDetail.RES_GET_PROMOTION_DETAIL:
		return { ...state, data: action.data, status: "fetch_result" };
	case ActionsPromotionDetail.ERR_GET_PROMOTION_DETAIL:
		return {
			...state, data: {}, status: "fetch_error", message: "Error...",
		};
	default: {

		return {
			...state,
		};

	}

	}

}

export default storePromotionDetail;
